import React from 'react'
import {
    Card, CardHeader,
    Col,
    Container,
    Media, Nav,
} from "reactstrap";
import Button from "reactstrap/es/Button";
import Row from "reactstrap/es/Row";
import WeekDay from "../WeekView/WeekDay";
import ClassApiService from "../../api/classes-api-service";

// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import dateHelpers from "../../helpers/DateHelper";
import {MdKeyboardArrowLeft, MdKeyboardArrowRight} from "react-icons/md";
import {FadingBalls} from "react-cssfx-loading";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);

const propTypes = {};

export default class DayPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshDayView: true,
            isLoading: false,
            events: [],
            todayDate: null,
            date: props.date,
            initialDate: props.date,
            daysInMonth: 0
        };

        window.DayPreview = this
        console.log(this.props)
    }

    componentWillUnmount() {
        window.DayPreview = null
    }

    componentDidMount() {
        this.getTodayEvents()
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.updateDayPreview === true) {
            this.getTodayEvents()
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (this.state.date !== nextState.date) {
            this.getTodayEvents(nextState.date)
        } else if (nextProps.date !== this.state.date && this.props.fromCalendar) {
            this.setState({date: nextProps.date})
        }
    }

    anotherDayEvents(e, val) {
        this.setState(prevState => {
            return {date: dateHelpers.addDay(prevState.date, val)}
        });

        e.preventDefault()
    }

    resetShift(e) {
        this.setState(prevState => {
            return {date: new Date()}
        });

        e.preventDefault()
    }

    refreshDayView = () =>
        this.setState({refreshDayView: !this.state.refreshDayView});

    getTodayEvents(date = this.state.date) {
        this.setState({isLoading: true, events: []});
        ClassApiService.dayEventsByDate(date)
            .then(res => {
                this.setState({
                    events: (res.events || []).concat(res.classes),
                    todayDate: res.date_web
                });

                this.refreshDayView();
                this.setState({isLoading: false})
            })
            .catch(function (error) {
                if (error.response && error.response.data.message.includes("too many segments")) {
                    window.location.reload() // this is when something goes wrong with token in localStorage
                }
            });
    }

    render() {
        this.localize();

        if (this.state.reloadCalendar === true) {
            this.getTodayEvents()
        }
        return (
            <Card className="shadow bg-transparent">
                <CardHeader className="border-0">
                    <Row className="align-items-center">
                        <div className="col">
                            <h3 className="mb-0">{commonStrings.navigation.schedule}</h3>
                        </div>

                        {this.props.fromCalendar !== true ?
                            (<div className="col">
                                <Nav className="justify-content-end" pills>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            minWidth: 30,
                                            marginRight: 10,
                                            minHeight: 30,
                                            boxShadow: "2px 2px 4px rgba(0,0,0,.2)",
                                            borderRadius: 15,
                                            background: "#323238",
                                            cursor: "pointer"
                                        }}
                                        onClick={e => this.anotherDayEvents(e, -1)}
                                    >
                                        <MdKeyboardArrowLeft color="white" size={20}/>️
                                    </div>
                                    {this.shouldShowTodayButton() &&
                                    <Button
                                        style={{margin: 0}}
                                        color="secondary"
                                        href="#pablo"
                                        onClick={e => this.resetShift(e)}
                                        size="sm"
                                    >
                                        <span className="d-none d-md-block">{commonStrings.navigation.today}</span>
                                        <span className="d-md-none">{"Today"}</span>
                                    </Button>
                                    }
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            minWidth: 30,
                                            marginLeft: 10,
                                            minHeight: 30,
                                            boxShadow: "2px 2px 4px rgba(0,0,0,.2)",
                                            borderRadius: 15,
                                            background: "#323238",
                                            cursor: "pointer"
                                        }}
                                        onClick={e => this.anotherDayEvents(e, 1)}
                                    >
                                        <MdKeyboardArrowRight color="white" size={20}/>️
                                    </div>
                                </Nav>
                            </div>) : (
                                <Button
                                    color="warning"
                                    onClick={e => this.props.closeDayPreview(e)}
                                    size="sm"
                                >
                                    <span className="d-none d-md-block">{commonStrings.close}</span>
                                    <span className="d-md-none">{commonStrings.close}</span>
                                </Button>
                            )
                        }
                    </Row>
                </CardHeader>

                {this.state.isLoading &&
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center", width: "100%"}}>
                        <FadingBalls color="#272853" duration="3s" />
                    </div>
                }

                {this.state.events &&
                <WeekDay dayName={this.state.todayDate ? dateHelpers.formatDate(new Date(this.state.todayDate)) : ""}
                         showEvents={true} dayEvents={this.state.events}
                         refresh={this.state.refreshDayView}
                         fromCalendar={this.props.fromCalendar}
                         goToClass={this.props.goToClass}
                         openEvent={this.props.openEvent}
                         showOneClassModal={this.props.addClass}
                         subUser={this.props.subUser}
                         date={this.state.date}
                />
                }
            </Card>
        )
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    shouldShowTodayButton() {
        const res = this.state.date !== this.state.initialDate
        return res
    }
}

DayPreview.propTypes = propTypes;